export default __webpack_public_path__ + "static/media/compliance.2396f51f.png";